// src/pages/battle/MyBattleListPage.jsx
import { useState } from "react";

import useMyBattleList from "../../hooks/useMyBattleList";
import BattleCard from "../../components/battle/BattleCard";
import BattlePageHeader from "../../components/battle/BattlePageHeader";
import { useJWT } from "../../contexts/JWTContext";

const STATUS_TABS = [
  { value: null, label: "전체" },
  { value: 0, label: "모집중" },
  { value: 1, label: "모집완료" },
  { value: 2, label: "종료" },
];

const ACCENT = "rgb(0, 224, 198)";

export default function MyBattleListPage() {
  const jwt = useJWT();
  const userId = jwt?.userId || null;

  const [statusFilter, setStatusFilter] = useState(null);

  const { battles, loading, error } = useMyBattleList({
    userId,
    statusFilter,
  });

  const handleBack = () => window.history.back();

  return (
    <div className="min-h-screen bg-slate-50 flex justify-center">
      {/* ✅ 화면 높이 고정 + 내부 스크롤 분리 */}
      <div className="w-full max-w-md h-screen flex flex-col overflow-hidden">
        {/* ✅ 상단 고정 영역(헤더 + 탭) */}
        <div className="sticky top-0 z-50 bg-slate-50">
          <BattlePageHeader
            title="내 대결 목록"
            showBack
            backButtonProps={{ onClick: handleBack }}
          />

          {/* ✅ 탭 영역 */}
          <div className="px-5 pt-4 pb-3 mx-2">
            <section>
              <div className="inline-flex rounded-full bg-white/80 backdrop-blur shadow-sm p-2">
                {STATUS_TABS.map((tab) => {
                  const isActive = statusFilter === tab.value;
                  return (
                    <button
                      key={String(tab.value)}
                      type="button"
                      onClick={() => setStatusFilter(tab.value)}
                      className="px-4 py-1 rounded-full text-xs font-medium transition"
                      style={
                        isActive
                          ? {
                              backgroundColor: "rgba(0, 224, 198, 0.14)",
                              color: ACCENT,
                              border: `1px solid ${ACCENT}`,
                            }
                          : { color: "#64748b" }
                      }
                    >
                      {tab.label}
                    </button>
                  );
                })}
              </div>
            </section>
          </div>
        </div>

        {/* ✅ 아래만 스크롤되는 리스트 영역 */}
        <main className="flex-1 overflow-y-auto px-5 pb-24 mx-2">
          <section className="space-y-3 mt-2">
            {loading && (
              <p className="text-center text-xs text-slate-400">
                내 대결을 불러오는 중입니다...
              </p>
            )}

            {error && (
              <p className="text-center text-xs text-red-500">
                내 대결을 불러오지 못했어요. 잠시 후 다시 시도해 주세요.
              </p>
            )}

            {!loading && !error && battles.length === 0 && (
              <p className="text-center text-xs text-slate-400">
                참여한 대결이 아직 없어요.
              </p>
            )}

            {!loading &&
              !error &&
              battles.map((battle) => (
                <BattleCard key={battle.battleId} battle={battle} />
              ))}
              {!loading && !error && battles.length > 0 && <div className="h-28" />}
          </section>
        </main>
      </div>
     
    </div>
  );
}
